// extracted by mini-css-extract-plugin
module.exports = {"cont-docs":"cont-docs","contDocs":"cont-docs"};